module.exports = __webpack_public_path__ + "static/media/icon-mdf.bb631ee9.svg";